import './errorScreen.scss';
import { Button } from '../Button/Button';
import { Card } from '../Card/Card';
import WarningImage from '../../../images/warning.png';
import RetryIcon from '../../../images/retry-icon.png';

export const ErrorScreen = ({ retry, message }) => {
  return (
    <div className="error-screen">
      <div className="error-container">
        <img className="warning-image" src={WarningImage} alt={'warning'} />
        <div className="warning-error-text">{message}</div>
        <Button style={{ width: '100%' }} onClick={retry} text={'Retry'} icon={RetryIcon} iconPosition={'prefix'} />
      </div>
    </div>
  );
};
